var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"show"},[_c('div',{attrs:{"id":"code_wrapper"}},[_c('div',{class:_vm.select_class,attrs:{"name":"code","id":"code"}},[_vm._v(_vm._s(_vm.code))])])])}
var staticRenderFns = []

export { render, staticRenderFns }